import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions";
import { Site } from "../../../models/Site";
import TRACE_API, { baseQuery, reducerPath } from "../../api_client/trace_api";

const tagTypes = ["Site", "Station"];

export type SiteAPIEndpointBuilder = EndpointBuilder<
  typeof baseQuery,
  typeof tagTypes[number],
  typeof reducerPath
>;

const sitesModelsEndpoints = TRACE_API.injectEndpoints({
  endpoints: (builder: SiteAPIEndpointBuilder) => ({
    /*
    |---------------------------------------------------------------------
    |                          Site Queries & Mutations
    |---------------------------------------------------------------------
    */

    fetchAllSites: builder.query<Site[], void>({
      query: () => ({
        url: "/sites",
        method: "GET",
      }),
      providesTags: ["Site"],
    }),

    fetchOneSite: builder.query<Site[], void>({
      query: ({ site_id }: any) => ({
        url: `/sites/${site_id}`,
        method: "GET",
      }),
      providesTags: ["Site"],
    }),

    createSite: builder.mutation<void, Site>({
      query(data: any) {
        return {
          url: "/sites",
          method: "POST",
          body: data,
        };
      },
      invalidatesTags: ["Site"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetch,
  useFetchAllSitesQuery,
  useFetchOneSiteQuery,
  useCreateSiteMutation,
} = sitesModelsEndpoints;
